import React, { Fragment, useEffect, useRef, useState } from 'react';
import {
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
  useMediaQuery
} from '@mui/material';
import {
  getFinancialPyramid,
  resetFinancialPyramid,
  saveFinancialPyramid,
  updateFinancialPyramid,
  updateFinancialPyramidInputs
} from '../../../store/financialPyramid/duck';
import EditIcon from '@mui/icons-material/Edit';
import PresentModeSwitch from '../../PolicyReview/PresentModeSwitch/PresentModeSwitch';
import _ from 'lodash';
import FinancialPyramid from './FinancialPyramid';
import { isClientDisconnected, setClientIdLocalStorage } from '../../../components/ClientEntry/utils';
import PolicyReviewChooseClient from '../../PolicyReview/PolicyReviewChooseClient/PolicyReviewChooseClient';
import { getClientById, submitClient, updateViewingClient } from '../../../store/client/duck';
import MeetingDialog from '../../../components/ClientEntry/MeetingDialog/MeetingDialog';
import { getPDF } from '../../../store/pdf/api';
import moment from 'moment-timezone';
import { toast } from 'react-toastify';
import { LOADING, SUCCESS } from '../../../constants/phase';
import TagsDialog from '../../../components/ClientEntry/TagsDialog/TagsDialog';
import FinancialConceptButton from './FinancialConceptButton/FinancialConceptButton';
import ModeSwitch from './ModeSwitch/ModeSwitch';
import ConfirmSaveDialog from './ConfirmSaveDialog/ConfirmSaveDialog';
import IconToast from '../../../components/NewToast';
import LeavePageConfirm from '../../../components/LeavePageConfirm/LeavePageConfirm';
import ConfirmSwitchClientDialog from './ConfirmSwitchClientDialog/ConfirmSwitchClientDialog';
import ExportHintDialog from '../../../components/ExportHintDialog/ExportHintDialog';
import { tracking } from '../../../utils/tracking';
import './FinancialPyramidContainer.scss';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { usePrevious } from '../../../utils/hooks';
import { hasCampaignCode, isAdviserType } from '../../../utils/user';
import AnalysisButton from './AnalysisButton/AnalysisButton';
import PreviewWrapper from '../../../pdf-templates/PreviewWrapper';
import LanguageRadioGroup from '../../../components/LanguageRadioGroup/LanguageRadioGroup';
import ExitWhiteboardDialog from '../../../components/MyWhiteboard/ExitWhiteboardDialog/ExitWhiteboardDialog';
import MyWhiteboard from '../../../components/MyWhiteboard/MyWhiteboard';
import WhiteboardButton from './WhiteboardButton/WhiteboardButton';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import { isSubscriptionAllowAction } from '../../../utils/user-subscription-store';
import NativeOrWeb from '../../../utils/native';
import ExpenseCalculatorButton from './ExpenseCalculatorButton/ExpenseCalculatorButton';
import SelectButtonGroup from '../../../components/SelectButtonGroup/SelectButtonGroup';
import { getDefaultFinancialPyramidCopy, getFinancialPyramidDataFromSearch } from './utils';
import WhiteboardRemoteHintDialog from './WhiteboardRemoteHintDialog/WhiteboardRemoteHintDialog';
import RemoteButton from './RemoteButton/RemoteButton';
import EditDisplayNamesDialog from '../../../components/EditDisplayNamesDialog/EditDisplayNamesDialog';
import produce from 'immer';
import { toggleDialog } from '../../../store/control/duck';
import PolicyPicker from '../../../components/PolicyPicker/PolicyPicker';
import animateScrollTo from 'animated-scroll-to';
import LoadingBackdrop from '../../../components/LoadingBackdrop/LoadingBackdrop';
import AladdinHint from '../../../components/AladdinHint/AladdinHint';
import { trackDirect } from '../../../store/analytics/api';
import { trackViewership } from '../../../utils/tracking/index';
import { getSearchObject } from '../../../utils/router';

const FullWidthStyle = {
  width: '100%'
};

const FinancialPyramidContainer = props => {
  const {
    intl,
    history,
    userDetails,
    viewingClient,
    clientData,
    getClientByIdPhase,
    handwritingMode,
    presentMode,
    financialPyramid,
    language,
    pyramidIndex,
    loading,
    fetchClientPhase,
    createClientPhase,
    getPhase,
    updatePhase,
    teamCampaignCodes,
    updateViewingClient,
    getClientById,
    updateFinancialPyramidInputs,
    updateFinancialPyramid,
    getFinancialPyramid,
    saveFinancialPyramid,
    submitClient,
    resetFinancialPyramid,
    toggleDialog
  } = props;

  const infoSectionRef = useRef(null);
  const expenseUpdateEditFlagRef = useRef(null);
  const expenseUpdateDetailsRef = useRef(null);
  const hydratedSearchRef = useRef();
  const requestedQueryClientRef = useRef();
  const fetchedPyramidClientIdRef = useRef();
  const shouldScrollToExpenseCalculatorRef = useRef(false);

  const [internalFinancialPyramid, setInternalFinancialPyramid] = useState(financialPyramid);
  const [updated, setUpdated] = useState(false);
  const [editEntriesDisplayNameDialog, setEditEntriesDisplayNameDialog] = useState(false);
  const [confirmSaveDialog, setConfirmSaveDialog] = useState(false);
  const [confirmChangeClientDialog, setConfirmChangeClientDialog] = useState(false);
  const [hintDialog, setHintDialog] = useState(false);
  const [exitWhiteboardDialog, setExitWhiteboardDialog] = useState(false);
  const [monthlyIncome, setMonthlyIncome] = useState(_.get(viewingClient, 'factsheetId.monthlyIncome', 0)); //sets default value on monthly income
  const [monthlyExpense, setMonthlyExpense] = useState(_.get(viewingClient, 'factsheetId.monthlyExpense', 0)); //sets default value on monthly expense
  const [expenses, setExpenses] = useState(_.get(viewingClient, 'factsheetId.expenses', {})); //sets default value on expenses
  const [showIncome, setShowIncome] = useState(true);
  const [showRecord, setShowRecord] = useState(true);
  const [showIncomeAnimation, setShowIncomeAnimation] = useState(true);
  const [showRecordAnimation, setShowRecordAnimation] = useState(true);
  const [whiteboardRemoteHintDialog, setWhiteboardRemoteHintDialog] = useState(false);
  const [showExpenseCalculator, setShowExpenseCalculator] = useState(true);
  const [showExpenseCalculatorAnimation, setShowExpenseCalculatorAnimation] = useState(true);
  const [policyPicker, setPolicyPicker] = useState(false);

  const prevGetPhase = usePrevious(getPhase);
  const prevUpdatePhase = usePrevious(updatePhase);
  const prevCreateClientPhase = usePrevious(createClientPhase);

  const financialPyramidEntry = _.get(
    internalFinancialPyramid,
    `entries[${pyramidIndex}]`,
    getDefaultFinancialPyramidCopy(language)
  );
  const { emergencyFund } = financialPyramidEntry || {};

  const isSM = useMediaQuery(theme => theme.breakpoints.up('sm'));
  const isMD = useMediaQuery(theme => theme.breakpoints.up('md'));

  const clientName = isAdviserType(userDetails) ? _.get(viewingClient, 'factsheetId.name') : _.get(userDetails, 'name');
  const currency = _.get(userDetails, 'currency', 'HKD');
  const clientId = _.get(viewingClient, '_id');
  const factsheetId = _.get(viewingClient, 'factsheetId._id');

  const shouldShownRemoteButton = isSM && hasCampaignCode(userDetails, teamCampaignCodes, 'REMOTEWHITEBOARD');

  const switchHandwritingMode = () => {
    if (handwritingMode === true) {
      setExitWhiteboardDialog(true);
    } else {
      tracking('Click on Whiteboard- Financial pyramid');
      updateFinancialPyramidInputs('handwritingMode', true);
      updateFinancialPyramidInputs('presentMode', true);
    }
  };
  const switchPresentMode = event => updateFinancialPyramidInputs('presentMode', event.target.checked);
  const openEditEntriesDisplayNameDialog = () => setEditEntriesDisplayNameDialog(true);
  const closeEditEntriesDisplayNameDialog = () => setEditEntriesDisplayNameDialog(false);
  const openConfirmSaveDialog = () => setConfirmSaveDialog(true);
  const closeConfirmSaveDialog = () => setConfirmSaveDialog(false);
  const closeChangeClientDialog = () => setConfirmChangeClientDialog(false);
  const closeHintDialog = () => setHintDialog(false);
  const closeExitWhiteboardDialog = () => {
    updateFinancialPyramidInputs('handwritingMode', false);
    updateFinancialPyramidInputs('presentMode', false);
    setExitWhiteboardDialog(false);
  };
  const closeWhiteboardRemoteHintDialog = () => {
    setWhiteboardRemoteHintDialog(false);
  };

  const onChange = data => {
    if ('monthlyIncome' in data) {
      setMonthlyIncome(data.monthlyIncome);
    }

    if ('monthlyExpense' in data) {
      setMonthlyExpense(data.monthlyExpense);
    }

    if ('expenses' in data) {
      setExpenses(data.expenses);
    }

    for (let key of ['risk', 'investment', 'saving', 'protection', 'emergencyFund']) {
      if (key in data) {
        const newState = produce(internalFinancialPyramid, draft => {
          draft.entries[pyramidIndex][key] = data[key];
        });
        setInternalFinancialPyramid(newState);
      }
    }
    setUpdated(true);
  };

  const selectClient = client => {
    const isDisconnected = isClientDisconnected(client);
    if (!isDisconnected) {
      if (_.get(history, 'location.search')) {
        history.replace({
          pathname: _.get(history, 'location.pathname'),
          search: '',
          hash: _.get(history, 'location.hash')
        });
      }
      setUpdated(false);
      updateViewingClient(client);
      setClientIdLocalStorage(_.get(client, '_id'));
    }
  };
  const onSelectClient = client => {
    if (updated) {
      setConfirmChangeClientDialog(client);
    } else {
      updateFinancialPyramidInputs('pyramidIndex', 0);
      selectClient(client);
    }
  };
  const confirmSelectClient = () => {
    expenseUpdateEditFlagRef.current = null;
    expenseUpdateDetailsRef.current = null;
    updateFinancialPyramidInputs('pyramidIndex', 0);
    selectClient(confirmChangeClientDialog);
    setConfirmChangeClientDialog(false);
  };

  const save = () => {
    const clientId = _.get(viewingClient, '_id');
    if (clientId) {
      saveFinancialPyramid(clientId, internalFinancialPyramid);

      if (userDetails) {
        const { factsheetId, email } = viewingClient || {};
        submitClient({
          monthlyIncome: monthlyIncome,
          monthlyExpense: monthlyExpense,
          expenses: expenses,

          advisorId: userDetails._id,
          connectedAdviserEmail: userDetails.email,

          clientId: clientId,
          _id: factsheetId._id,
          email: email
        });
      }
    }
    setUpdated(false);
  };

  const saveDisplayNames = displayNames => {
    const clientId = _.get(viewingClient, '_id');
    if (clientId) {
      // update state
      if (internalFinancialPyramid && internalFinancialPyramid.entries) {
        const newFinancialPyramid = produce(internalFinancialPyramid, draft => {
          for (const [index, displayName] of (displayNames || []).entries()) {
            if (index <= draft.entries.length - 1) {
              draft.entries[index].displayName = displayName;
            } else {
              draft.entries.push({
                ...getDefaultFinancialPyramidCopy(intl.locale),
                displayName: displayName
              });
            }
          }
        });

        setInternalFinancialPyramid(newFinancialPyramid);
      }

      // save
      if (financialPyramid && financialPyramid.entries) {
        const newFinancialPyramid = produce(financialPyramid, draft => {
          for (const [index, displayName] of (displayNames || []).entries()) {
            if (index <= draft.entries.length - 1) {
              draft.entries[index].displayName = displayName;
            } else {
              draft.entries.push({
                ...getDefaultFinancialPyramidCopy(intl.locale),
                displayName: displayName
              });
            }
          }
        });

        if (saveFinancialPyramid) {
          saveFinancialPyramid(clientId, newFinancialPyramid);
        }
      }
    }
    closeEditEntriesDisplayNameDialog();
  };

  const generate = () => {
    if (!isSubscriptionAllowAction({ type: 'core', nicknames: ['Pro', 'Ultra'] })) {
      return;
    }

    setHintDialog(true);
  };

  const onConfirmGenerate = async ({ password, isPrivateMode }) => {
    if (!loading) {
      tracking('Click on PDF export - Financial pyramid', { adviser: userDetails });
      updateFinancialPyramidInputs('loading', true);

      try {
        const options = {
          clientName,
          currency,
          monthlyIncome,
          monthlyExpense,
          emergencyFund,
          financialPyramidEntry,
          handwritingMode,
          language,
          showIncome,
          showRecord,
          showExpenseCalculator,
          expenses,
          adviser: userDetails,
          outputFormat: 'pdf',
          password,
          isPrivateMode
        };

        const pdfBlob = await getPDF('financial-pyramid', options);
        trackDirect('exportFinancialPyramid');
        await NativeOrWeb.downloadFile(
          pdfBlob,
          `Financial_Pyramid_${(clientName || 'Client').split(' ')[0]}_v${pyramidIndex + 1}_${moment().format(
            'DDMMMYYYY'
          )}.pdf`,
          'application/pdf'
        );
      } catch (error) {
        toast.error(error.message);
      } finally {
        updateFinancialPyramidInputs('loading', false);
      }
    }
  };

  const onChangeLanguage = event => {
    const getNewInputDataAfterLanguageChange = (defaultData, currentData, nextData) => {
      return currentData.map((item, index) => {
        const defaultItem = _.get(defaultData, `[${index}]`);

        if (defaultItem) {
          if (item.name === defaultItem.name) {
            const nextName = _.get(nextData, `[${index}].name`, item.name);
            return { ...item, name: nextName };
          }
        }

        return item;
      });
    };

    for (let target of ['risk', 'investment', 'saving', 'protection']) {
      onChange({
        [target]: getNewInputDataAfterLanguageChange(
          getDefaultFinancialPyramidCopy(language)[target],
          financialPyramidEntry[target],
          getDefaultFinancialPyramidCopy(event.target.value)[target]
        )
      });
    }

    updateFinancialPyramidInputs('language', event.target.value);
  };
  const onChangeShowIncome = () => {
    setShowIncomeAnimation(!showIncome);
  };
  const onChangeShowRecord = () => {
    setShowRecordAnimation(!showRecord);
  };
  const onShowIncomeAnimationDone = () => {
    setShowIncome(showIncomeAnimation);
    if (expenseUpdateEditFlagRef.current) {
      expenseUpdateEditFlagRef.current = null;
      if (infoSectionRef && infoSectionRef.current) {
        const wrappedComponent = infoSectionRef.current.getWrappedInstance();
        wrappedComponent.toggleInfoEdit(true);
      }
    }
  };
  const onShowRecordAnimationDone = () => {
    setShowRecord(showRecordAnimation);
  };
  const onToggleShowExpenseCalculator = () => {
    const nextShowExpenseCalculator = !showExpenseCalculator;
    shouldScrollToExpenseCalculatorRef.current = nextShowExpenseCalculator;
    setShowExpenseCalculatorAnimation(nextShowExpenseCalculator);
  };
  const onShowExpenseCalculatorAnimationDone = () => {
    setShowExpenseCalculator(showExpenseCalculatorAnimation);
    if (showExpenseCalculatorAnimation && shouldScrollToExpenseCalculatorRef.current) {
      animateScrollTo(document.body.scrollHeight, { minDuration: 1000 }).then();
      shouldScrollToExpenseCalculatorRef.current = false;
    }
  };
  const onSubmitExpenses = (total, expenses) => {
    setMonthlyExpense(total);
    setExpenses(expenses);
    setUpdated(true);
    expenseUpdateDetailsRef.current = { total: total };

    if (showIncome) {
      // if (infoSectionRef && infoSectionRef.current) {
      //   const wrappedComponent = infoSectionRef.current.getWrappedInstance();
      //   wrappedComponent.toggleInfoEdit(true);
      // }
    } else {
      expenseUpdateEditFlagRef.current = true;
      setShowIncomeAnimation(true);
    }
  };

  const goToRemote = () => {
    setWhiteboardRemoteHintDialog(true);
  };

  const openPolicyPicker = details => {
    setPolicyPicker(details);
  };

  const onSubmitPolicyPicker = policies => {
    const { onSubmit } = policyPicker;
    if (onSubmit) {
      onSubmit(policies);
    }
  };

  const onClosePolicyPicker = () => {
    // InputTableGrid suppresses blur-to-apply while the picker is open; clear that
    // latch on both submit (PolicyPicker calls onClose after onSubmit) and cancel.
    const { onClose } = policyPicker || {};
    if (onClose) {
      onClose();
    }
    setPolicyPicker(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    tracking('Financial Pyramid Accessed');
    trackDirect('viewFinancialPyramid');
    trackViewership('financial-pyramid', {
      'Page Path': window.location.pathname,
      'Page URL': window.location.href,
      'Page Domain': window.location.hostname,
      Interval: 180000
    });
  }, []);

  useEffect(() => {
    if (getPhase === SUCCESS && getPhase !== prevGetPhase) {
      setInternalFinancialPyramid(financialPyramid);
    }
  }, [getPhase, prevGetPhase, financialPyramid]);

  useEffect(() => {
    const currentSearch = _.get(history, 'location.search', '');
    if (!currentSearch) {
      return;
    }

    const searchObject = getSearchObject({ location: { search: currentSearch } }) || {};
    const queryClientId = _.get(searchObject, 'clientId');
    if (!queryClientId) {
      return;
    }

    if (_.get(viewingClient, '_id') === queryClientId) {
      return;
    }

    const foundClient = (clientData || []).find(client => _.get(client, '_id') === queryClientId);
    if (foundClient) {
      const isDisconnected = isClientDisconnected(foundClient);
      if (!isDisconnected) {
        setUpdated(false);
        updateViewingClient(foundClient);
        setClientIdLocalStorage(_.get(foundClient, '_id'));
      }
      return;
    }

    if (getClientByIdPhase !== LOADING && requestedQueryClientRef.current !== queryClientId) {
      requestedQueryClientRef.current = queryClientId;
      getClientById(queryClientId);
    }
  }, [clientData, getClientById, getClientByIdPhase, history.location.search, updateViewingClient, viewingClient]);

  useEffect(() => {
    updateFinancialPyramidInputs('language', intl.locale);
  }, [intl.locale, updateFinancialPyramidInputs]);

  useEffect(() => {
    const currentSearch = _.get(history, 'location.search', '');
    const searchObject = getSearchObject({ location: { search: currentSearch } }) || {};
    const queryClientId = _.get(searchObject, 'clientId');
    const viewingClientId = _.get(viewingClient, '_id');
    const prefilledData = getFinancialPyramidDataFromSearch(searchObject, {});
    const { factsheetPatch } = prefilledData;

    const shouldApplyFactsheetPatch = !!queryClientId && queryClientId === viewingClientId;

    const nextMonthlyIncome =
      shouldApplyFactsheetPatch && factsheetPatch.hasMonthlyIncome
        ? factsheetPatch.monthlyIncome
        : _.get(viewingClient, 'factsheetId.monthlyIncome', 0);
    setMonthlyIncome(nextMonthlyIncome);

    let nextMonthlyExpense =
      shouldApplyFactsheetPatch && factsheetPatch.hasMonthlyExpense
        ? factsheetPatch.monthlyExpense
        : _.get(viewingClient, 'factsheetId.monthlyExpense', 0);
    if (expenseUpdateDetailsRef.current) {
      nextMonthlyExpense = expenseUpdateDetailsRef.current.total;
      expenseUpdateDetailsRef.current = null;
    }
    setMonthlyExpense(nextMonthlyExpense);

    if (viewingClient?.factsheetId?.expenses) {
      let nextExpenses = { ...viewingClient.factsheetId.expenses };
      if (shouldApplyFactsheetPatch && factsheetPatch.hasExpenses) {
        nextExpenses = { ...nextExpenses, ...factsheetPatch.expenses };
      }
      setExpenses(nextExpenses);
    } else {
      setExpenses(shouldApplyFactsheetPatch && factsheetPatch.hasExpenses ? { ...factsheetPatch.expenses } : {});
    }
  }, [history.location.search, viewingClient]);

  useEffect(() => {
    setClientIdLocalStorage(viewingClient?._id);
  }, [viewingClient, history]);

  useEffect(() => {
    const viewingClientId = _.get(viewingClient, '_id');
    if (!viewingClientId) {
      fetchedPyramidClientIdRef.current = undefined;
      return;
    }

    if (fetchedPyramidClientIdRef.current === viewingClientId) {
      return;
    }

    const isDisconnected = isClientDisconnected(viewingClient);
    if (!isDisconnected) {
      fetchedPyramidClientIdRef.current = viewingClientId;
      getFinancialPyramid(viewingClientId);
    }
  }, [getFinancialPyramid, viewingClient]);

  useEffect(() => {
    const currentSearch = _.get(history, 'location.search', '');
    if (!currentSearch || hydratedSearchRef.current === currentSearch) {
      return;
    }

    const searchObject = getSearchObject({ location: { search: currentSearch } }) || {};
    const queryClientId = _.get(searchObject, 'clientId');
    const viewingClientId = _.get(viewingClient, '_id');

    if (queryClientId && viewingClientId !== queryClientId) {
      return;
    }

    const prefilledData = getFinancialPyramidDataFromSearch(searchObject, financialPyramidEntry);
    const { factsheetPatch, entryPatch, hasFactsheetChanges, hasEntryChanges, hasChanges } = prefilledData;

    if (hasEntryChanges) {
      if (getPhase !== SUCCESS) {
        return;
      }

      if (queryClientId && fetchedPyramidClientIdRef.current !== queryClientId) {
        return;
      }

      if (!clientId || (financialPyramid.clientId && financialPyramid.clientId !== clientId)) {
        return;
      }
    }

    if (!hasChanges) {
      hydratedSearchRef.current = currentSearch;
      return;
    }

    if (hasFactsheetChanges) {
      if (factsheetPatch.hasMonthlyIncome) {
        setMonthlyIncome(factsheetPatch.monthlyIncome);
      }
      if (factsheetPatch.hasMonthlyExpense) {
        setMonthlyExpense(factsheetPatch.monthlyExpense);
      }
      if (factsheetPatch.hasExpenses) {
        setExpenses(currentExpenses => ({ ...(currentExpenses || {}), ...factsheetPatch.expenses }));
      }
    }

    let nextFinancialPyramid = internalFinancialPyramid;
    if (hasEntryChanges) {
      nextFinancialPyramid = produce(internalFinancialPyramid || { entries: [] }, draft => {
        if (!Array.isArray(draft.entries)) {
          draft.entries = [];
        }

        if (!draft.entries[pyramidIndex]) {
          draft.entries[pyramidIndex] = getDefaultFinancialPyramidCopy(language);
        }

        draft.entries[pyramidIndex] = entryPatch.entry;
      });
      setInternalFinancialPyramid(nextFinancialPyramid);
    }

    hydratedSearchRef.current = currentSearch;
    setUpdated(true);
  }, [
    clientId,
    financialPyramid.clientId,
    financialPyramidEntry,
    getPhase,
    history.location.search,
    internalFinancialPyramid,
    language,
    pyramidIndex,
    viewingClient
  ]);

  useEffect(() => {
    if (createClientPhase === true && updatePhase === SUCCESS) {
      if (prevCreateClientPhase !== true || prevUpdatePhase !== SUCCESS) {
        toast.info(IconToast('success', intl.formatMessage({ id: 'saved-successfully' })), { className: 'new-toast' });
      }
    }
  }, [createClientPhase, updatePhase, prevUpdatePhase, prevCreateClientPhase, intl]);

  useEffect(() => {
    return () => {
      resetFinancialPyramid();
    };
  }, [resetFinancialPyramid]);

  useEffect(() => {
    return () => {
      expenseUpdateEditFlagRef.current = null;
      expenseUpdateDetailsRef.current = null;
    };
  }, []);

  const versionChoices = [0, 1].map(index => {
    const defaultLabel = intl.formatMessage({ id: 'fin-py-ver' }, { index: index + 1 });
    const getDisplayName = entry => {
      return entry.displayName ? entry.displayName : defaultLabel;
    };
    return {
      label: internalFinancialPyramid.entries[index]
        ? getDisplayName(internalFinancialPyramid.entries[index])
        : defaultLabel,
      value: index,
      disabled: !clientId
    };
  });

  const VersionButtons = () => (
    <SelectButtonGroup
      buttonClassName="version-button"
      value={pyramidIndex}
      choices={versionChoices}
      onChange={event => {
        updateFinancialPyramidInputs(
          'pyramidIndex',
          event.target.value === undefined ? (pyramidIndex === 0 ? 1 : 0) : event.target.value
        );
      }}
    />
  );

  return (
    <div id="financial-pyramid">
      <Container
        className="financial-pyramid-container"
        maxWidth="xl"
        style={{ padding: !presentMode ? '50px 16px calc(62px + var(--bottom-padding))' : 0 }}
      >
        <LeavePageConfirm shouldShow={updated} save={save} />

        <ConfirmSwitchClientDialog
          open={confirmChangeClientDialog !== false}
          onClose={closeChangeClientDialog}
          onConfirm={confirmSelectClient}
        />

        <ExportHintDialog
          open={hintDialog}
          onClose={closeHintDialog}
          onConfirm={onConfirmGenerate}
          shouldUsePassword={true}
        />

        <ExitWhiteboardDialog open={exitWhiteboardDialog} onClose={closeExitWhiteboardDialog} />

        <WhiteboardRemoteHintDialog open={whiteboardRemoteHintDialog} onClose={closeWhiteboardRemoteHintDialog} />

        <PolicyPicker
          userId={!isClientDisconnected(viewingClient) ? _.get(viewingClient, '_id') : undefined}
          open={!!policyPicker}
          onClose={onClosePolicyPicker}
          onSubmit={onSubmitPolicyPicker}
          shouldResetPickedAfterSubmit={true}
        />

        {(fetchClientPhase === LOADING ||
          createClientPhase === LOADING ||
          getPhase === LOADING ||
          updatePhase === LOADING) && <LoadingBackdrop open={true} />}

        {!presentMode && (
          <Fragment>
            <MeetingDialog />
            <TagsDialog />
          </Fragment>
        )}

        <ConfirmSaveDialog
          pyramidIndex={pyramidIndex}
          open={confirmSaveDialog}
          onClose={closeConfirmSaveDialog}
          onConfirm={save}
        />

        <EditDisplayNamesDialog
          open={editEntriesDisplayNameDialog}
          onClose={closeEditEntriesDisplayNameDialog}
          displayNames={versionChoices.map(choice => choice.label)}
          onConfirm={saveDisplayNames}
        />

        <Grid container spacing={2} sx={{ flexDirection: 'column' }}>
          {!presentMode && (
            <Grid>
              <AladdinHint title={intl.formatMessage({ id: 'aladdin-demo-video' })} helpCenter="c39" />
            </Grid>
          )}

          {!isSM && (
            <Grid style={{ ...FullWidthStyle, textAlign: 'right' }}>
              <Fragment>
                {handwritingMode ? (
                  <IconButton onClick={switchHandwritingMode} size="large">
                    <ClearRoundedIcon />
                  </IconButton>
                ) : !presentMode ? (
                  <PresentModeSwitch
                    checked={presentMode}
                    onChange={switchPresentMode}
                    label={intl.formatMessage({ id: 'present-mode' })}
                  />
                ) : null}
              </Fragment>
            </Grid>
          )}

          <Grid style={FullWidthStyle}>
            {!viewingClient && (
              <Typography color="error">{intl.formatMessage({ id: 'select-client-hint' })}</Typography>
            )}
            <Grid
              container
              sx={{
                alignItems: 'center',
                justifyContent: handwritingMode ? 'flex-end' : 'space-between'
              }}
            >
              {!presentMode ? (
                <Grid style={{ flexGrow: 1 }}>
                  <Grid container sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                    <Grid style={{ width: '100%', whiteSpace: 'pre' }}>
                      <Grid
                        container
                        sx={{
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <Grid>
                          <Grid
                            container
                            spacing={1}
                            sx={{
                              alignItems: 'center'
                            }}
                          >
                            <Grid>
                              <PolicyReviewChooseClient
                                selectedClient={viewingClient}
                                setSelectedClient={onSelectClient}
                              />
                            </Grid>
                            {!handwritingMode && (
                              <Grid>
                                <Grid
                                  container
                                  sx={{
                                    alignItems: 'center'
                                  }}
                                >
                                  <Grid>
                                    <VersionButtons />
                                  </Grid>
                                  <Grid>
                                    <IconButton
                                      disabled={!clientId}
                                      onClick={openEditEntriesDisplayNameDialog}
                                      size="large"
                                    >
                                      <EditIcon style={{ fontSize: 18 }} />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                            <Grid>
                              <Grid
                                container
                                wrap="nowrap"
                                style={{
                                  border: '1px solid #3966f8',
                                  borderRadius: 8
                                }}
                                sx={{
                                  alignItems: 'center'
                                }}
                              >
                                <Grid>
                                  <FinancialConceptButton style={{ padding: '3px 8px' }} />
                                </Grid>
                                <Grid>
                                  <ExpenseCalculatorButton
                                    clientId={clientId}
                                    expenses={expenses}
                                    onSubmit={onSubmitExpenses}
                                  />
                                </Grid>
                                <Grid>
                                  <AnalysisButton client={viewingClient} style={{ padding: '3px 8px' }} />
                                </Grid>
                                <Grid>
                                  <WhiteboardButton onClick={switchHandwritingMode} style={{ padding: '3px 8px' }} />
                                </Grid>
                                {shouldShownRemoteButton && (
                                  <Grid>
                                    <RemoteButton onClick={goToRemote} style={{ padding: '3px 8px' }} />
                                  </Grid>
                                )}
                              </Grid>
                            </Grid>
                            <Grid>
                              <Grid
                                container
                                spacing={1}
                                wrap="nowrap"
                                style={{ minHeight: 66 }}
                                sx={{
                                  alignItems: 'center'
                                }}
                              >
                                <Grid>
                                  <Button
                                    color={updated ? undefined : 'primary'}
                                    variant="contained"
                                    onClick={openConfirmSaveDialog}
                                    style={{
                                      padding: '2px 8px',
                                      background: updated ? 'red' : undefined,
                                      color: updated ? 'white' : undefined
                                    }}
                                    disabled={!viewingClient}
                                  >
                                    {intl.formatMessage({ id: 'save-data' })}
                                  </Button>
                                </Grid>
                                <Grid>
                                  <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={generate}
                                    style={{ padding: '2px 8px' }}
                                    disabled={!viewingClient || loading}
                                  >
                                    {loading ? (
                                      <CircularProgress size={24.5} />
                                    ) : (
                                      `${intl.formatMessage({ id: 'Export_action' })} PDF`
                                    )}
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        {isSM && (
                          <Grid>
                            {handwritingMode ? (
                              <IconButton onClick={switchHandwritingMode} size="large">
                                <ClearRoundedIcon />
                              </IconButton>
                            ) : (
                              <PresentModeSwitch
                                checked={presentMode}
                                onChange={switchPresentMode}
                                label={intl.formatMessage({ id: 'present-mode' })}
                              />
                            )}
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              ) : !handwritingMode ? (
                <Fragment>
                  <Grid style={{ paddingLeft: 8 }}>
                    <VersionButtons />
                  </Grid>
                  <Grid>
                    <PresentModeSwitch
                      checked={presentMode}
                      onChange={switchPresentMode}
                      label={intl.formatMessage({ id: 'present-mode' })}
                    />
                  </Grid>
                </Fragment>
              ) : (
                <Grid>
                  <IconButton onClick={switchHandwritingMode} size="large">
                    <ClearRoundedIcon />
                  </IconButton>
                </Grid>
              )}
              {!presentMode && (
                <Grid>
                  <Grid container sx={{ flexDirection: 'column', alignItems: 'flex-end' }}>
                    <Grid>
                      <LanguageRadioGroup value={language} onChange={onChangeLanguage} />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>

          <Grid style={{ ...FullWidthStyle, border: !presentMode ? '3px solid #cbafe6' : undefined, padding: 8 }}>
            <PreviewWrapper locale={language}>
              <FinancialPyramid
                adviser={userDetails}
                clientName={clientName}
                clientId={clientId}
                factsheetId={factsheetId}
                currency={currency}
                monthlyIncome={monthlyIncome}
                monthlyExpense={monthlyExpense}
                emergencyFund={emergencyFund}
                financialPyramidEntry={financialPyramidEntry}
                handwritingMode={handwritingMode}
                onChange={onChange}
                showIncome={showIncome}
                showRecord={showRecord}
                onChangeShowIncome={onChangeShowIncome}
                onChangeShowRecord={onChangeShowRecord}
                showIncomeAnimation={showIncomeAnimation}
                showRecordAnimation={showRecordAnimation}
                onShowIncomeAnimationDone={onShowIncomeAnimationDone}
                onShowRecordAnimationDone={onShowRecordAnimationDone}
                infoSectionRef={infoSectionRef}
                expenseUpdateDetailsRef={expenseUpdateDetailsRef}
                showExpenseCalculator={showExpenseCalculator}
                onToggleShowExpenseCalculator={onToggleShowExpenseCalculator}
                showExpenseCalculatorAnimation={showExpenseCalculatorAnimation}
                onShowExpenseCalculatorAnimationDone={onShowExpenseCalculatorAnimationDone}
                expenses={expenses}
                onSubmitExpenses={onSubmitExpenses}
                toggleDialog={toggleDialog}
                openPolicyPicker={openPolicyPicker}
              />
            </PreviewWrapper>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

const container = connect(
  state => ({
    userDetails: state.user.userDetails,
    viewingClient: state.client.viewingClient,
    clientData: state.client.clientData,
    getClientByIdPhase: state.client.getClientByIdPhase,
    fetchClientPhase: state.client.fetchClientPhase,
    createClientPhase: state.client.createClientPhase,
    categories: state.policy.categories,
    portfolio: state.policy.portfolio,
    fetchPhase: state.policy.fetchPhase,
    teamCampaignCodes: state.functions.campaignCodes,
    ...state.financialPyramid
  }),
  {
    updateViewingClient,
    getClientById,
    updateFinancialPyramidInputs,
    updateFinancialPyramid,
    getFinancialPyramid,
    saveFinancialPyramid,
    submitClient,
    resetFinancialPyramid,
    toggleDialog
  }
)(FinancialPyramidContainer);

export default injectIntl(container);
